let language = {
    SELECT_STORE_PRODUCT_TYPE_TITLE:"Please select the type of store product you want to add",
    SELECT_STORE_PRODUCT_TYPE_NULL_TYPE_TIP:"There are currently no store product types for you to choose from",
    // 店铺产品类型
    SELECT_STORE_PRODUCT_TYPE_FULL_PROPERTY_WITHOUT_DESIGN_NAME:"Add a blank fully customizatble product",
    SELECT_STORE_PRODUCT_TYPE_FULL_PROPERTY_WITHOUT_DESIGN_DES:"Provide your customers with the flexibility to fully customize the product, with all the printing features and options to their liking.",
    SELECT_STORE_PRODUCT_TYPE_SKU_WITH_DESIGN_NAME:"Add Your Design",
    SELECT_STORE_PRODUCT_TYPE_SKU_WITH_DESIGN_DES:"Add your own unique designs to our products. In the later step, you'll have the option to let customers customize your designs or keep them as-is. Once you're done, simply add them to your store and get ready to make some sales!",
    SELECT_STORE_PRODUCT_TYPE_FULL_WITHOUT_DESIGN_NAME:"Add Blank Product",
    SELECT_STORE_PRODUCT_TYPE_FULL_WITHOUT_DESIGN_DES:"Add a blank product to your eShop and enable customer customization with text and pictures.",

    // 成品产品--可添加店铺产品类型名称
    SELECT_STORE_PRODUCT_TYPE_SKU_PRODUCT_NAME:"Add Blank Product",
    SELECT_STORE_PRODUCT_TYPE_FULL_PROPERTY_NAME: "Add a blank fully customizatble product",
    
    // 成品产品--可添加店铺产品类型名称
    SELECT_STORE_PRODUCT_TYPE_SKU_WITH_DESIGN_BINDING_NAME: "ADD DESIGN AND LINK TO EXISTING PRODUCT",
    SELECT_STORE_PRODUCT_TYPE_SKU_WITH_DESIGN_BINDING_DES: "Add your own design and link QPMN products to your existing Etsy listings to keep your reviews intact and streamline order fulfillment."
};

export { language }